import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { StorageService } from '../../services/storage.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const storage = inject(StorageService);
  const LOGIN_ROUTE = '/login';
  const LOGIN_REDIRECT_DELAY_MS = 100;
  const HANDLE_401_URL_PREFIXES = ['/api/nav-em', '/api/nav-ia', '/api/notification'] as const;

  let isUnauthorizedRedirectInProgress = false;

  const isAllowed401Url = (url: string): boolean => {
    return HANDLE_401_URL_PREFIXES.some((prefix) => url.includes(prefix));
  };

  const redirectToLoginOnce = (): void => {
    if (isUnauthorizedRedirectInProgress) {
      return;
    }
    isUnauthorizedRedirectInProgress = true;
    storage.clearToken();

    setTimeout(() => {
      router.navigateByUrl(LOGIN_ROUTE).finally(() => {
        isUnauthorizedRedirectInProgress = false;
      });
    }, LOGIN_REDIRECT_DELAY_MS);
  };

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let errorMessage = 'An error occurred';

      if (error.error instanceof ErrorEvent) {
        // Client-side error
        errorMessage = `Error: ${error.error.message}`;
      } else {
        // Server-side error
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;

        // Handle specific HTTP status codes
        switch (error.status) {
          case 401:
            if (isAllowed401Url(req.url)) {
              redirectToLoginOnce();
              console.warn(`401 for allowed URL: ${req.url}`);
            }
            break;
          case 403:
            // Forbidden
            console.error('Access forbidden');
            break;
          case 404:
            // Not found
            console.error('Resource not found');
            break;
          case 500:
            // Internal server error
            console.error('Internal server error');
            break;
        }
      }

      console.error(errorMessage);
      return throwError(() => error);
    })
  );
};
